import React, { FC } from 'react'

import { cx, css } from '@linaria/core'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'

import { formaDJRCyrillicTextFontFamily } from '../shared/fonts/formaDJRCyrillic/formaDJRCyrillicFontFamily'
import { OnlineSvg } from '../svgr/OnlineSvg'

export const Online: FC<{
  size: 8 | 12
  variant?: 'footer-status' | 'badge-status'
  isVerified?: boolean
}> = ({ size, variant, isVerified }) => {
  const hasText =
    variant === 'footer-status' || (variant === 'badge-status' && !isVerified)

  return (
    <Parent
      className={cx(
        onlineDefaultColorCss,
        hasText && gapCss,
        variant === 'badge-status' && onlineBadgeColorCss
      )}
      data-name="status-online"
    >
      <OnlineSvg width={size} height={size} />
      {hasText && <FormattedMessage id="app.online" defaultMessage="Онлайн" />}
    </Parent>
  )
}

const Parent = styled.span`
  display: inline-grid;
  grid-template-columns: repeat(2, auto);
  align-items: center;
  vertical-align: top;
  font-size: 14px;
  font-family: ${formaDJRCyrillicTextFontFamily};
`

const gapCss = css`
  grid-gap: var(--spacing-4px);
  gap: var(--spacing-4px);
`

const onlineDefaultColorCss = css`
  color: var(--success-default);
`

const onlineBadgeColorCss = css`
  color: var(--static-white);
`
